/* eslint-disable @stylistic/padding-line-between-statements */
import {effect, inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ScanWalletQRRequest, ScanWalletQRUseCase} from '../use-cases/scan-wallet-qr.use-case';
import {Wallet} from '../../domain/model/wallet.model';
import {WalletStatus, WalletStore} from '../store/wallet.store';
import {PAYMENT_FEEDBACK} from '@features/payment/domain/ports/ui/feedback.port';

@Injectable({providedIn: 'root'})
export class ScanWalletFacade {
  private readonly store = inject(WalletStore);
  private readonly scanWalletQR = inject(ScanWalletQRUseCase);
  private readonly notifier = inject(PAYMENT_FEEDBACK);

  constructor() {
    effect(() => this.syncFeedback(), {allowSignalWrites: true});
  }

  execute(request: ScanWalletQRRequest): Observable<Wallet | null> {
    return this.scanWalletQR.execute(request);
  }

  private syncFeedback(): void {
    const {status, error} = this.store.state();

    if (status === WalletStatus.LOADING) {
      this.notifier.showLoading('fv_modal.scan_qr_loader.loading_information');
      return;
    }

    if (status === WalletStatus.ERROR || status === WalletStatus.FETCH) {
      this.notifier.hideLoading();
    }

    if (status === WalletStatus.ERROR) {
      this.notifier.showError(error ?? 'fv_snackbar.wallet.scan_error_title');
    }
  }
}
